export default __webpack_public_path__ + "static/onboarding-consultants-integrating-lms-salesforce-1e718a0950f2ed223c17f1530cbf2818.jpg";